import {Component, Input, OnInit} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {ExgModalService} from 'exc-controls-v2';
import {ApplicationService} from '../../services/application.service';

@Component({
  selector: 'app-receipt-object-editor',
  templateUrl: './receipt-object-editor.component.html'
})
export class ReceiptObjectEditorComponent extends ExcTranslation implements OnInit {
  @Input()
  data: any;
  rcptObjectList = [] as any[];
  rcptObject: any;
  searchValue = '';
  countTrue = 0;

  constructor(
    private modal: ExgModalService,
    public enumSvc: EnumerationService,
    private appSvc: ApplicationService
  ) {
    super();
  }

  ngOnInit(): void {
    this.initialize();
    this.initEnumeration();
  }

  initialize(): void {
    this.rcptObject =
      this.data?.rcptObject
        ? JSON.parse(this.data.rcptObject)
      : [];
  }

  initEnumeration(): void {
    const copiedEnumList = this.appSvc.helperObj.clone(this.enumSvc.getEnumerationList('ReceiptLeistung'));
    copiedEnumList
      .forEach((enm: any) => {
        if (this.rcptObject) {
          const data = this.rcptObject;

          if (data.length > 0) {
            enm.enmValue = ExcCoreModule.Array.ExistsObject(data, 'enmIdent', enm.enmIdent);
          }
        }
        const obj = {
          enmValue: enm.enmValue,
          enmText: enm.enmText,
          uiTooltip: enm.uiTooltip,
          enmTextA: enm.enmTextA,
          enmIdent: enm.enmIdent,
        };
        this.rcptObjectList.push(obj);
      });
  }

  getReceiptObjectList(): any[] {
    if (!this.rcptObjectList) {
      return [];
    }
    this.countTrue = ExcCoreModule.Array.GetAll(this.rcptObjectList, 'enmValue', true).length;
    return this.rcptObjectList
      .filter(
        // Suchtext in den OEs
        rcptObj => this.searchValue === ''
          || JSON.stringify(rcptObj).toLowerCase().indexOf(this.searchValue.toLowerCase()) > -1
      );
  }

  search(value: string): void {
    this.searchValue = value;
  }

  cancel(): void {
    this.modal.close();
  }

  save(): void {
    this.modal.action({rcptObject: JSON.stringify(
        ExcCoreModule.Array.GetAll(this.rcptObjectList, 'enmValue', true)
          .map((objElement: any) => {
            return {
              enmIdent: objElement.enmIdent,
              enmText: objElement.enmText
            };
          })
      )
    });
  }
}
